import {
  $confirmTicketFileUpload,
  $createTicketFile,
  $deleteTicketFile,
} from '@rematter/modules/trade/_state/scaleTicketPhotos.state';
import { useSetAtom } from 'jotai';

import { FileMutations } from '~/modules/trade/types/file';

export const useTicketFiles = (): FileMutations => {
  // Atoms
  const createLoadFile = useSetAtom($createTicketFile);
  const confirmUpload = useSetAtom($confirmTicketFileUpload);
  const deleteFile = useSetAtom($deleteTicketFile);

  return {
    createFile: async (params) => {
      const result = await createLoadFile({
        purchaseLoadId: params.entityId,
        fileName: params.fileName,
        mimeType: params.mimeType,
        fileSize: params.fileSize,
      });

      return {
        id: result.tradePurchaseLoadFileCreate.file.id,
        uploadUrl: result.tradePurchaseLoadFileCreate.uploadUrl as string,
      };
    },
    confirmUpload: async (params) => {
      await confirmUpload({ fileId: params.fileId });

      return { url: '' };
    },
    deleteFile: async (params) => {
      await deleteFile({ fileId: params.fileId });
    },
  };
};
